<template>
    <div class="p-t-sm" v-if="data">
        <div class="block">
            <router-link :to="{ name: 'meetings.edit',params:{
                id:meetingId
            } }" class="button is-dark m-r-sm">Back</router-link>
        </div>
        <div class="block">
            <p class="is-size-2 has-text-weight-bold">
                Edit Point {{this.data.attributes.name}}
            </p>
        </div>
        <div class="block">
            <div class="card">
                <div class="card-content">
                    <div class="columns">
                        <div class="column is-6">
                            <b-field label="Name">
                                <b-input v-model="data.attributes.name">
                                </b-input>
                            </b-field>
                            <b-field label="Details">
                                <b-input v-model="data.attributes.details" type="textarea">
                                </b-input>
                            </b-field>
                            <b-field label="Action For">
                                <b-input v-model="data.attributes.action_for">
                                </b-input>
                            </b-field>
                            <b-field label="App">
                                <b-select v-model="data.attributes.app_id" expanded>
                                    <option :value="app.id" v-for="(app,key) in apps" :key="key">{{app.name}}</option>
                                </b-select>
                            </b-field>
                            <div class="block">
                                <b-field label="Archive?">
                                    <b-switch v-model="data.attributes.archived_at"
                                        :true-value="true"
                                        :false-value="null"
                                        type="is-danger"
                                        passive-type="is-success">
                                    </b-switch>
                                </b-field>
                            </div>
                        </div>
                    </div>
                    <section class="m-t-md">
                        <router-link :to="{ name: 'meetings.edit',params:{
                            id:meetingId
                        } }" class="button is-default m-r-sm">Cancel</router-link>
                        <b-button type="is-success m-r-sm" @click.prevent="save">Save</b-button>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default {
    data() {
        return {
            data:null
        }
    },
    computed:{
        id() {
            return this.$router.currentRoute.params.id
        },
        meetingId() {
            return this.$router.currentRoute.params.meetingId
        },
    },
    async mounted() {
        await this.getAppList()
        this.getPoint()
    },
    methods:{
        getAppList() {
            Vue.$appService.appList().then((response)=>{
                this.apps = response
                this.loading = false;
            });
        },
        getPoint() {
            Vue.$pointService.getPoint(this.id).then((response)=>{
                this.data = response.data
                this.data.attributes.archived_at = this.data.attributes.archived_at ? true : false
            })
        },
        save() {
            Vue.$pointService.updatePoint(this.id,this.data.attributes).then((response)=>{
                this.data = response.data;
                this.data.attributes.archived_at = this.data.attributes.archived_at ? true : false
                this.$buefy.toast.open({
                    type:'is-success',
                    message:'Point saved!'
                })
            })
        }
    }
}
</script>